import React, { useEffect, useState, useContext } from "react";
import DateFnsUtils from '@date-io/date-fns'
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import useFetch from './useFetch'
import Validation from "./Validation";
import moment from 'moment';
import { ThemeContext } from '../Helper/Context'
window.scrollTo(0, 0)
const Addchild = ({ childId, onSubmit }) => {
    const [{ response }, dofetch] = useFetch();
    const [apiName, setApiName] = useState(null)
    const { mainState, setMainState, setShowLoader } = useContext(ThemeContext);
    const [errors, setErrors] = useState({ errors: true })

    const params = new URLSearchParams(window.location.search);

    mainState.children.map((child, index) => {
        mainState.children[index].selected = false
    })
    const [child, setChild] = useState(
        {
            id: mainState.children.length,
            selected: true,
            firstName:params ? params.get("firstname") : ''
        },
    )
    // console.log(child)
    const [formFields, setFormFields] = useState({
        id: {
            value: 1
        },
        firstName: {
            value: params ? params.get("firstname") : '',
            required: true,
            type: 'text'
        },
        lastName: {
            value: '',
            required: true,
            type: 'text'
        },
        birthDate: {
            value: null,
            required: true,
            type: 'date'
        },
        gender: {
            value: '',
            required: true,
            type: 'radio'
        },
        healthIssueDetails: {
            value: '',
            required: false,
            type: 'text'
        },

    })

    const handleDate = (date) => {
        // let formatedDate = ("0" + date.getDate()).slice(-2) + '/' + date.getMonth() + '/' + date.getFullYear();
        setFormFields(prevState => ({
            ...prevState,
            birthDate: {
                ...prevState.birthDate, value: date
            }
        }))

        setChild(prevState => ({
            ...prevState, birthDate: moment(date).format(' YYYY-MM-DD'),
        }))
    }

    const handleChange = (e) => {
        setFormFields(prevState => ({
            ...prevState,
            [e.target.name]: {
                ...prevState[e.target.name], value: e.target.value
            }
        }))

        setChild(prevState => ({
            ...prevState, [e.target.name]: e.target.value
        }))
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setErrors(Validation(formFields));

    }

    const updateChildren = (e) => {
        
        // console.log(child)

        let userData = {
            homeClubId: 1,
            parentMemberId: mainState.user.userId,
            personalData: {
                firstName: child.firstName,
                lastName: child.lastName,
                birthDate: moment(child.birthDate).format('YYYY-MM-DD'),
                sex: child.gender,
                phoneNumber: mainState.user.phoneNumber,
                citizenshipCountrySymbol: "AU",
                personalId: child.firstName.substring(0,2)+"."+moment(child.birthDate).format('YYYY-MM-DD').substring(0,4)+"."+child.lastName.substring(0,2)+".chi",
                Citizenship: 'Australia',
                
            },
            addressData: {
                street: mainState.user.address.street,
                postalCode: mainState.user.address.postalCode,
                city: mainState.user.address.city,
            },
            customAttributes: [
                {
                    customAttributeTypeId: 9,
                    value: mainState.user.firstName+" "+mainState.user.lastName
                }, {
                    customAttributeTypeId: 10,
                    value: mainState.user.phoneNumber,
                },
                {
                    customAttributeTypeId: 11,
                    value: "Parent"
                },
    
            ]
            

            
            
        }
        console.log(userData);
        // setErrors(true);
        dofetch(mainState.fetchURL, 'AddGuestMember', 'AddGuestMember.post.odata', '', JSON.stringify(userData));
        
    }


    useEffect(() => {
        if (response) {
            console.log(response);
            setShowLoader(false);
            if(apiName === 'notes'){
                onSubmit(false, false, true);
            }else{
                if (response.errors) {
                    alert(response.errors[0].message)
                }else if(response.message){
                    alert(response.message)
                }
                else {
                    child.id = response.memberId;
                    setMainState(prevState =>({
                        ...prevState,
                        children:[...mainState.children, child]
                    }))
                    if(child.healthIssueDetails !== ""){
                        let notes = {
                            memberId: response.memberId,
                            note: child.healthIssueDetails,
                            blockAccess: true,
                            isPinned: true
                          }
                        setShowLoader(true);
                        setApiName('notes')
                        dofetch(mainState.fetchURL, 'AddMemberNote', 'AddMemberNote.post.odata', '', JSON.stringify(notes));
                        
                    }else{
                        onSubmit(false, false, true);
                    }
                }
            }
            
        }
    }, [response])


    useEffect(() => {
        if (!errors) {
            updateChildren();
            setErrors(true);
        }
    }, [errors]);

    return (
        <>
            <p>Please provide details about your child.</p>

            <h2>Your child details:</h2>
            {/* <h2>Your personal details</h2> */}
            <div className="form">
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="firstname">First name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="firstname" name="firstName" placeholder="First Name"
                                value={formFields.firstName.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.firstName &&
                            <span className="EditingFormErrorLabel">Please first name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="lastname">Last name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="lastname" name="lastName" placeholder="Last Name"
                                value={formFields.lastName.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.lastName &&
                            <span className="EditingFormErrorLabel">Please enter last name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="dateOfBirth">Birth date</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control datepickercontrol">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    letiant="inline"
                                    format="dd/MM/yyyy"
                                    value={formFields.birthDate.value}
                                    onChange={date => handleDate(date)}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        {errors.birthDate &&
                            <span className="EditingFormErrorLabel">Please enter valid birth date</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <span className="label">Gender</span>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <span className="radio radio-list-horizontal">
                                <input id="Male" type="radio" name="gender"
                                    defaultValue="Male" onChange={e => handleChange(e)} />
                                <label htmlFor="Male">Male</label>

                                <input id="Female" type="radio" name="gender"
                                    defaultValue="Female" onChange={e => handleChange(e)} />
                                <label htmlFor="Female">Female</label>

                                <input id="prefernottosay" type="radio" name="gender"
                                    defaultValue="Prefer not to say" onChange={e => handleChange(e)} />
                                <label htmlFor="prefernottosay">Prefer not to say</label>
                            </span>
                        </div>
                        {errors.gender &&
                            <span className="EditingFormErrorLabel">Please enter gender</span>
                        }
                    </div>
                </div>
                {/* <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="phoneNumber">Phone number</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="phoneNumber" name="phoneNumber" placeholder="0400 000 000"
                                value={formFields.phoneNumber.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.phoneNumber &&
                            <span className="EditingFormErrorLabel">Please enter valid phone number</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="citizenship">Citizenship</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="citizenship" name="citizenship" placeholder="Type your citizenship"
                                value={formFields.citizenship.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.citizenship &&
                            <span className="EditingFormErrorLabel">Please enter citizenship</span>
                        }
                    </div>
                </div> */}
                <h3>Health Issues</h3>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="healthIssueDetails">Health Issue detail:</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <textarea rows={2} cols={20} className="form-control" autoComplete="off" name="healthIssueDetails" id="healthIssueDetails"
                                placeholder="Please type"
                                value={formFields.healthIssueDetails.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.healthIssueDetails &&
                            <span className="EditingFormErrorLabel">Please write health issue detail</span>
                        }

                    </div>
                </div>
                <div className="form-row form-row-submit">
                    <div className="form-element">
                        <div className="btn-wrapper">
                            <button className="FormButton btn" value="Done" onClick={(e) => handleFormSubmit(e)} >add</button>
                            <button className="btn btn-border" onClick={(e) => onSubmit(false, false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Addchild